module.exports = __webpack_public_path__ + "static/media/equilibre_rouge.ff7e96d3.svg";